import {Component, OnDestroy, OnInit} from '@angular/core';
import {Observable, Subscription} from "rxjs";
import {AuthenticationModel, UserDataModel, UserModel} from "../../../model/userModel";
import {CompanyModel} from "../../company/model/company.model";
import {ProductModel} from "../../../model/product.model";
import {ArticleModel} from "../../../model/article.model";
import {NewsModel} from "../../../model/news.model";
import {UserService} from "../../../service/user/user.service";
import {Store} from "@ngrx/store";
import {AppState} from "../../../app.state";
import {CompanyService} from "../../company/service/company.service";
import {ProductService} from "../../../service/product/product.service";
import {ArticleService} from "../../../service/article/article.service";
import {Router} from "@angular/router";
import {NewsService} from "../../news/service/news.service";
import {faHome, faUserCog, faUser, faNewspaper, faAd, faHeart} from '@fortawesome/free-solid-svg-icons'

@Component({
  selector: 'app-user-account',
  templateUrl: './user-account.component.html',
  styleUrls: ['./user-account.component.scss']
})
export class UserAccountComponent implements OnInit, OnDestroy {

  authentication: Observable<AuthenticationModel>;
  authenticationData;

  userObservable: Observable<UserModel>;
  userSub: Subscription;
  userData: UserDataModel;

  companies: CompanyModel[];
  products: ProductModel[];
  articles: ArticleModel[];
  news: NewsModel[] = [];

  faHome: any;
  faUserCog: any;
  faUser: any;
  faNewspaper: any;
  faAd: any;
  faHeart: any;

  constructor(private userService: UserService,
              private store: Store<AppState>,
              private companyService: CompanyService,
              private productService: ProductService,
              private articleService: ArticleService,
              private router: Router,
              private newsService: NewsService) {
    this.userSub = this.store.select('user').subscribe(user => {
      this.authenticationData = user.authentication;
      if (user.user) {
        this.userData = user.user;
      }
    });
    this.faHome = faHome;
    this.faUserCog = faUserCog;
    this.faUser = faUser;
    this.faNewspaper = faNewspaper;
    this.faAd = faAd;
    this.faHeart = faHeart;
  }

  ngOnInit() {
    if (this.userData && this.userData.authority.includes('GUEST')) {
      //redirect guest users to the complete registration page
      this.router.navigate([`/email-verify/${this.userData.id}`])
    } else if (!this.userData) {
      this.router.navigate([`/login`])
    }
  }

  ngOnDestroy(): void {
    this.userSub.unsubscribe();
  }

 /* getUserCompanies(userId: number) {
    this.companyService.getCompanies(userId)
      .subscribe((companies: CompanyModel[]) => {
        this.companies = companies;
      })
  }*/

/*  getUserProducts(userId: number) {
    this.productService.getProductsForOrganisation(userId)
      .subscribe((productModels: ProductModel[]) => {
        console.log(productModels);
        this.products = productModels;
      })
  }*/

/*  getUserArticles() {
    this.articleService.getArticles(0)
      .subscribe(articles => {
        this.articles = articles;
      })
  }*/

 /* getNews() {
    this.newsService.getNewsPage(0)
      .subscribe((news: NewsModel[]) => {
        this.news = news;
      })
  }*/

  isUserAdminRole() {
    return this.userData && this.userData.authority.includes('ADMIN');
  }
}
